export default __webpack_public_path__ + "static/media/ico-drop-droite.45b536cb.svg";